/**
 * PermissionStatusIcon Component
 * Displays appropriate icon based on permission state
 */

import React from 'react'
import { Box } from '@mui/material'
import { VideoCameraIcon, MicrophoneIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { PermissionState } from '../../helpers/permissionHelpers'

interface PermissionStatusIconProps {
  permissionState: PermissionState
  hasError: boolean
}

export const PermissionStatusIcon: React.FC<PermissionStatusIconProps> = ({ permissionState, hasError }) => {
  const isDenied = permissionState === 'denied'

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {hasError || isDenied ? (
        <ExclamationTriangleIcon style={{ width: 48, height: 48, color: INTERAX_COLORS.sun }} />
      ) : (
        <>
          <VideoCameraIcon style={{ width: 48, height: 48, color: INTERAX_COLORS.sun }} />
          <MicrophoneIcon style={{ width: 48, height: 48, color: INTERAX_COLORS.sun }} />
        </>
      )}
    </Box>
  )
}
